export const SHORTCUTS = {
  UNDO: { key: "z", meta: true, shift: false, label: "Undo" },
  REDO: { key: "z", meta: true, shift: true, label: "Redo" },
  DELETE: { key: "Delete", meta: false, shift: false, label: "Delete selected" },
  BACKSPACE_DELETE: { key: "Backspace", meta: false, shift: false, label: "Delete selected" },
  DESELECT: { key: "Escape", meta: false, shift: false, label: "Deselect" },
  EXPORT_PDF: { key: "e", meta: true, shift: false, label: "Export PDF" },
  NUDGE_LEFT: { key: "ArrowLeft", meta: false, shift: false, label: "Nudge left" },
  NUDGE_RIGHT: { key: "ArrowRight", meta: false, shift: false, label: "Nudge right" },
  NUDGE_UP: { key: "ArrowUp", meta: false, shift: false, label: "Nudge up" },
  NUDGE_DOWN: { key: "ArrowDown", meta: false, shift: false, label: "Nudge down" },
  LAYER_FORWARD: { key: "]", meta: true, shift: false, label: "Bring forward" },
  LAYER_BACKWARD: { key: "[", meta: true, shift: false, label: "Send backward" },
  LAYER_TO_FRONT: { key: "]", meta: true, shift: true, label: "Bring to front" },
  LAYER_TO_BACK: { key: "[", meta: true, shift: true, label: "Send to back" },
};

export const matchesShortcut = (event, shortcut) => {
  const metaOrCtrl = event.metaKey || event.ctrlKey;
  if (shortcut.meta && !metaOrCtrl) return false;
  if (!shortcut.meta && metaOrCtrl) return false;
  if (shortcut.shift && !event.shiftKey) return false;
  if (!shortcut.shift && event.shiftKey && shortcut.meta) return false;
  return event.key === shortcut.key || event.key.toLowerCase() === shortcut.key.toLowerCase();
};
